# navigation touch screen support
$(document).on "click", (e) ->
  if !$(e.target).is(".nav-wrapper *")
    $("#page-container").removeClass("nav-active")

$(".js-touch-nav").on "click", ->
  $("#page-container").toggleClass("nav-active")

# display notification if messages
if $(".js-nav-messages").length
  $.ajax
    url: "/messages/unread_message_count"
    success: (response) ->
      if response.unread_message_count > 0
        $(".js-nav-messages").addClass "notification-dot"

if $(".js-nav-ideation").length
  $.ajax
    type: "GET"
    url: "/pitches/unread"
    dataType: "script"

# footer thing like on calendar
if $(document).height() > $(window).height() * 2
  $(".footer-back").removeClass "active"
else
  $(".footer-back").addClass "active"




// WEBPACK FOOTER //
// ./app/javascript/lib/toolkit/page_nav.js.coffee